import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import SiteContext from 'site/SiteContext';
import { Body, Box, breakpoints, Card, SearchResultsGrid } from 'dma-ui-kit';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import ImageNotFound from 'assets/resultmissing.png';
import { translateInterfaceText } from 'helpers/translation';
import { fromUnixTime } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import useBreakpoint from 'use-breakpoint';

const NoLink = styled(Box)`
    padding: 0 10px;
`;

const EventLink = styled(Link)`
    padding: 0 10px;
`;

const UpcomingEvents = (props) => {
    const { attributes, relationships } = props.paragraph;

    const { data } = relationships.field_event_category;
    const limit = attributes.field_display_limit ? attributes.field_display_limit : 10;
    const [categoryItems, setCategoryItems] = useState([]);

    const noUpcomingEvents = translateInterfaceText("No upcoming events");

    const { breakpoint } = useBreakpoint(breakpoints);

    const showCategoryItems = () => {

        if (categoryItems.length < 1)
            return (
                <NoLink>
                    <Card 
                        image={ImageNotFound } 
                        title={noUpcomingEvents} 
                        alt={noUpcomingEvents}
                        caption={''}
                        variant="mini"
                    />
                </NoLink>
            );

        const results = categoryItems.map((result, index) => {
            return (
                <EventLink key={index} to={{ pathname: `${result.url[0]}` }}>
                    <Card 
                        image={result.featured_image ? result.featured_image[0] : ImageNotFound } 
                        title={result.title[0]} 
                        alt={result.featured_image_alt && result.featured_image_alt[0]}
                        caption={(
                            <Body variant='small'>
                                {formatInTimeZone(fromUnixTime(result.field_date_rrule[0]), 'America/Chicago', 'MMM do yyyy')}<br/>
                                {formatInTimeZone(fromUnixTime(result.field_date_rrule[0]), 'America/Chicago', 'h:mm aaa')} - {formatInTimeZone(fromUnixTime(result.date_rrule_end[0]), 'America/Chicago', 'h:mm aaa')}
                            </Body>
                        )}
                        variant="mini"
                    />
                </EventLink>
            );
        });
        return results;
    };

    const baseSearchURL = process.env.REACT_APP_SEARCH_BASE_PATH;
    const envir = process.env.REACT_APP_ENV;
    const { searchPath } = useContext(SiteContext);
    const searchEndpoint = `${baseSearchURL}${envir}${searchPath}_content_index/_search`;

    let pollCategoryItems = true;

    const getTilesPerRow = () => {
        switch(breakpoint) {
            case "mobile":
                return 1;
            case "tablet":
            case "tabletSmall":
                return 2;
            default:
                return 4;
        };
    };

    const getCategoryItems = async (categoryList) => {
        const date = Date.now() / 1000;

        const query = { 
            "query": { 
                "bool": { 
                    "must": [ 
                        { "query_string" : { 
                            "query": `${categoryList}`, 
                            "fields": ["field_event_category"]
                        }},
                        { "match": { "status": true }},
                        { "range" : {
                            "field_date_rrule" : { "gte" : `${date}` }
                        }}
                    ]
                }
            }, 
            "sort": [ 
                { "field_date_rrule": { "order" : "asc" }}
            ], 
            "size": `${limit}` 
        };
        
        const res = await axios.post(searchEndpoint, query);

        if (pollCategoryItems)
        {
            const hits = res.data.hits.hits.map(hit => ({ ...hit._source }));
            setCategoryItems(hits);
        }
    };

    const categories = data.map((item, index) => { return item.attributes.drupal_internal__tid; });
    const categoryList = categories.join(" OR ");

    useEffect(() => {
        getCategoryItems(categoryList);
        return () => {
            pollCategoryItems = false;
        };
    }, [categoryList]);
    
    return (
        <Box w="80%" margin="auto" center="center">
            <SearchResultsGrid cardsPerRow={getTilesPerRow()}>
                {showCategoryItems()}
            </SearchResultsGrid>
        </Box>
    );
};


export default withRouter(UpcomingEvents);